export enum CUSTOMERS_QUERIES_ENUM {
  SEARCH_CUSTOMERS = 'SEARCH_CUSTOMERS',
  GET_CUSTOMER = 'GET_CUSTOMER',
  GET_CUSTOMER_LOYALTY_STATUS = 'GET_CUSTOMER_LOYALTY_STATUS',
  TAG_COUNT_LIST = 'TAG_COUNT_LIST',
}
